// src/pages/Dashboard.js
import React, { useEffect, useState } from 'react';
import DashboardContent from '../../components/DashboardContent';
import ApiService from '../../Api/ApiController';


const Dashboard = () => {
    const [data,setData] = useState({});

    const fetchdashboard = ()=>{
        ApiService.getDashboard().then((response)=>{
            if(response.data.status){
                setData(response.data.data)
            }else{
                setData({})
            }
        })
    }
    useEffect(()=>{
        fetchdashboard()
    },[])
    return (
    <DashboardContent data={data}/>
);
}
export default Dashboard;
